import React, { useEffect, useState } from "react";
import { MapPin, X } from "lucide-react";
import { GEO_FALLBACK_NOTICE } from "../utils/getPositionWithFallback";

/**
 * Banner discreto quando la geolocalizzazione è negata/fallita e si usano coordinate di fallback.
 */
export default function GeoFallbackNotice({ visible, onDismiss, message = GEO_FALLBACK_NOTICE }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!visible) {
      setShow(false);
      return undefined;
    }
    const t = window.setTimeout(() => setShow(true), 80);
    return () => window.clearTimeout(t);
  }, [visible]);

  if (!visible && !show) return null;

  return (
    <div
      className={`geo-fallback-notice ${show ? "geo-fallback-notice--visible" : ""}`}
      role="status"
      aria-live="polite"
      data-testid="geo-fallback-notice"
    >
      <MapPin size={16} className="geo-fallback-notice__icon shrink-0" aria-hidden />
      <p className="geo-fallback-notice__text">{message}</p>
      {onDismiss ? (
        <button
          type="button"
          className="geo-fallback-notice__close"
          onClick={onDismiss}
          aria-label="Chiudi avviso"
          data-testid="geo-fallback-notice-dismiss"
        >
          <X size={16} />
        </button>
      ) : null}
    </div>
  );
}
